import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

function AboutUs() {
    const navigate = useNavigate();

    return (
        <div className="about-container">
            <div className="about-content">
                <h1>About ShredSaver</h1>

                <section className="about-section">
                    <h2>What We Do</h2>
                    <p>
                        ShredSaver helps you find the best prices on bike parts, accessories, tools, and complete bikes
                        across the top European bike retailers. We automatically search through thousands of products
                        to bring you the most competitive prices.
                    </p>
                </section>

                <section className="about-section">
                    <h2>Fresh Data</h2>
                    <p>
                        Our database is updated daily with the latest prices and availability.
                        All products shown are currently in stock and ready to order.
                    </p>
                </section>

                <section className="about-section support-section">
                    <h2>Support Us</h2>
                    <p>
                        If you find ShredSaver helpful, consider supporting us to keep the service running.
                        Your contribution helps us maintain and improve the platform.
                    </p>
                    <div className="stripe-button-wrapper">
                        <stripe-buy-button
                            buy-button-id="buy_btn_1SPhAK24r3b9jhDZjz2rd2pL"
                            publishable-key="pk_live_51SOQPn24r3b9jhDZ4LU7FlYS1LDgeB1V5CNBaxnOvSh5k27oF5tlodBLV1s46TJk5wfFx0RfRoCje1CEkd1btn7G00jcFnjJzP"
                        >
                        </stripe-buy-button>
                    </div>
                </section>

                <button onClick={() => navigate('/')} className="back-button">
                    ← Back to Search
                </button>
            </div>
        </div>
    );
}

export default AboutUs;
